import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Stack } from '@festina-life/ui/structure'

import { ParameterValuesTable } from '../../../components/parameterValues/ParameterValuesTable'
import { useLayoutContext } from '../../../context/layoutContext'
import { useParameterContext } from '../../../context/parameterContext'
import { ParameterAmendmentsAlert } from './ParameterAmendmentsAlert'
import { ParameterAmendmentsExportWarningAlert } from './ParameterAmendmentsExportWarningAlert'

export const ParameterValues = () => {
  const translate = useTranslate()
  const {
    parameterDefinitionOperation,
    parameterValueEntityOperationsForView,
    amendOperationsInView,
  } = useParameterContext()
  const {
    preferences: {
      parameters: { isShowingExtrinsicParameterValues },
    },
  } = useLayoutContext()

  const isRenderingAmendments = !!amendOperationsInView.length
  const isRenderingValues = !!parameterValueEntityOperationsForView?.length
  const isExtrinsicParameter =
    !!parameterDefinitionOperation?.internalOperation.entity?.isExtrinsic

  if (isRenderingAmendments) {
    return (
      <Stack className="flex-col">
        <ParameterAmendmentsAlert />
        <ParameterAmendmentsExportWarningAlert />
      </Stack>
    )
  }

  if (isRenderingValues) {
    return <ParameterValuesTable />
  }

  return (
    <Alert
      severity="warning"
      title={
        isExtrinsicParameter && !isShowingExtrinsicParameterValues
          ? translate('parameterViewer.values.emptyExtrinsic')
          : translate('parameterViewer.values.empty')
      }
      className="mt-2 max-w-full!"
    />
  )
}
